/**
 * Function used to sort an array of objects by a specific field name in ascending or descending order.
 *
 * @param {string} fieldName - The name of the field to sort by.
 * @param {boolean} asc - Whether to sort in ascending order (true) or descending order (false).
 * @returns {Function} - A comparator function used for sorting the array.
 */
export const byFieldName = (
  fieldName: string,
  asc?: boolean,
): ((
  a: { [key: string]: any },
  b: {
    [key: string]: any
  },
) => 1 | -1 | 0) => {
  return (a: { [key: string]: any }, b: { [key: string]: any }) => {
    if (
      typeof a[fieldName] === 'undefined' &&
      typeof b[fieldName] === 'undefined'
    )
      return 0
    // if a is undefined and b isn't a should have a lower index in the array
    else if (typeof a[fieldName] === 'undefined') return asc ? 1 : -1
    // if b is undefined and a isn't a should have a higher index in the array
    else if (typeof b[fieldName] === 'undefined') return asc ? -1 : 1
    if (a[fieldName] < b[fieldName]) return asc ? -1 : 1
    if (a[fieldName] > b[fieldName]) return asc ? 1 : -1
    return 0
  }
}

export const byCaseInsensitiveFieldName = (
  fieldName: string,
  asc: boolean,
): ((
  a: { [key: string]: any },
  b: { [key: string]: any },
) => 1 | -1 | 0) => {
  return (a: { [key: string]: any }, b: { [key: string]: any }) => {
    if (
      typeof a[fieldName] === 'undefined' &&
      typeof b[fieldName] === 'undefined'
    )
      return 0
    // if a is undefined and b isn't a should have a lower index in the array
    else if (typeof a[fieldName] === 'undefined') return asc ? 1 : -1
    // if b is undefined and a isn't a should have a higher index in the array
    else if (typeof b[fieldName] === 'undefined') return asc ? -1 : 1
    const fieldA = a[fieldName]?.toLowerCase()
    const fieldB = b[fieldName]?.toLowerCase()
    if (fieldA < fieldB) return asc ? -1 : 1
    if (fieldA > fieldB) return asc ? 1 : -1
    return 0
  }
}
